var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#48B288",
  fillRule: "evenodd",
  d: "M.786 6.5A5.714 5.714 0 0 1 6.5.786h11A5.714 5.714 0 0 1 23.214 6.5v11a5.714 5.714 0 0 1-5.714 5.714h-11A5.714 5.714 0 0 1 .786 17.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.209 7.683a1 1 0 0 1 .156 1.406l-6.286 7.857a1 1 0 0 1-1.38.175l-3.144-2.357a1 1 0 1 1 1.2-1.6l2.368 1.776 5.68-7.1a1 1 0 0 1 1.406-.157",
  clipRule: "evenodd"
})));
export default SvgCheck;